import type { PlanType, Subscription } from "@/types";
import { supabase } from "@cl/supabase";
import { handleSupabaseError } from "./_error";

export const fetchOwnSubscription = async (): Promise<Subscription | null> => {
  const { data, error } = await supabase
    .from("subscriptions")
    .select("*")
    .maybeSingle();
  if (error) handleSupabaseError(error, "fetchOwnSubscription");
  return data as Subscription | null;
};

export const checkPlanLimit = async (): Promise<boolean> => {
  const { data, error } = await supabase.rpc("check_plan_limit");
  if (error) handleSupabaseError(error, "checkPlanLimit");
  return data as boolean;
};

export interface CreateCheckoutSessionPayload {
  planType: Exclude<PlanType, "free">;
  successUrl: string;
  cancelUrl: string;
  /** Ciclo de facturación. Default server-side: "month". */
  interval?: "month" | "year";
}

export const createCheckoutSession = async (
  payload: CreateCheckoutSessionPayload,
): Promise<string> => {
  const { data, error } = await supabase.functions.invoke(
    "create-checkout-session",
    { body: payload },
  );
  if (error) throw new Error(error.message);
  return (data as { url: string }).url;
};

export const createPortalSession = async (returnUrl: string): Promise<string> => {
  const { data, error } = await supabase.functions.invoke(
    "create-portal-session",
    { body: { returnUrl } },
  );
  if (error) throw new Error(error.message);
  return (data as { url: string }).url;
};

export const fetchActiveTourCount = async (): Promise<number> => {
  const { count, error } = await supabase
    .from("tours")
    .select("id", { count: "exact", head: true });
  if (error) handleSupabaseError(error, "fetchActiveTourCount");
  return count ?? 0;
};

